/**
 * CampaignList
 *
 * Renders a list of campaigns with loading skeleton and edit-mode support.
 */
import React from 'react';
import CampaignRow from './CampaignRow';
import { RecentCampaignSkeleton } from '../../ui/feedback/skeleton.jsx';

export default function CampaignList({ 
  isLoading, 
  campaigns, 
  isEditMode, 
  onDelete, 
  onUpdate, 
  currentNamespaceId,
  hasReadOnlyPermission = false
}) {
  // When loading, show a skeleton
  if (isLoading) {
    return <RecentCampaignSkeleton />;
  }

  // Render the list of campaigns
  return (
    <div className="space-y-3">
      {campaigns.map((campaign) => (
        <CampaignRow
          key={campaign.id}
          campaign={campaign}
          onDelete={onDelete}
          onUpdate={onUpdate}
          isEditMode={isEditMode}
          currentNamespaceId={currentNamespaceId}
        />
      ))}
    </div>
  );
}